import React from "react";
import { Box, useTheme } from "../components";
export const convertToHexString = (hex, opacity) => {
    const alpha = Math.round(opacity * 255)
        .toString(16)
        .padStart(2, "0");
    return `#${hex.replace("#", "")}${alpha}`;
};
export const ShapeIcon = ({ oval = false, fill, stroke }) => {
    const theme = useTheme();
    const defaultOpacity = 0.9;
    const defaultColor = theme.palette.primary.main;
    return (React.createElement(Box, { sx: {
            borderRadius: oval ? (theme) => theme.radius.full : undefined,
            height: 2,
            width: 2,
            backgroundColor: convertToHexString((fill === null || fill === void 0 ? void 0 : fill.color) || defaultColor, (fill === null || fill === void 0 ? void 0 : fill.opacity) || defaultOpacity),
            border: stroke ? 0.5 : undefined,
            borderColor: stroke
                ? convertToHexString(stroke.color || defaultColor, stroke.opacity || defaultOpacity)
                : undefined,
        } }));
};
//# sourceMappingURL=ShapeIcon.js.map